import { render, staticRenderFns } from "./BoasVindas.vue?vue&type=template&id=24619853&scoped=true"
import script from "./BoasVindas.vue?vue&type=script&lang=js"
export * from "./BoasVindas.vue?vue&type=script&lang=js"
import style0 from "./BoasVindas.vue?vue&type=style&index=0&id=24619853&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24619853",
  null
  
)

export default component.exports